export default __webpack_public_path__ + "static/media/s.4771558a.mp4";